import React, {CSSProperties, useEffect} from 'react';
import {useNavigation, useParams, useSearchParams} from "react-router-dom";
import GlobalSpinner from "./GlobalSpinner";
import Tabs from "./Tabs";
import {useManageContext} from "../App";
import General from "../constants/General";
import {fetchTrip} from "../Helper";
import {LanguagesIds} from "../lang/i18n";
import Toast from "./Toast";

export default function Layout({children, style, className, isTripRequired = true}: {
    children: any,
    style?: CSSProperties | undefined,
    className?: string,
    isTripRequired?: boolean,
}) {

    const navigation = useNavigation();
    const {setTrip, trip, lang} = useManageContext();
    const {tripKey} = useParams();
    const [searchParams] = useSearchParams();

    const TourId = searchParams.get('TourId');

    useEffect(() => {
        (async () => {
            try {
                const trip = tripKey ? await fetchTrip(tripKey, LanguagesIds[lang], TourId) : undefined;
                setTrip(trip);
            } catch (e: any) {
                console.log(e.message, `${General.apiUrl}/driver-tasks`);
            }
        })();
    }, [tripKey, TourId, setTrip]);

    if (navigation.state === 'loading') {
        return <GlobalSpinner/>;
    }

    return (
        <div className="d-flex justify-content-center">
            <div className="d-block w-100 main limit-width position-relative">
                <div className={'body-content ' + className} style={style}>
                    {trip === null && isTripRequired && <GlobalSpinner/>}
                    {children}
                </div>
                <Toast/>
                <Tabs/>
            </div>
        </div>
    )
}